export default "__VITE_ASSET__91c206f6__"